var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTravel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3662 5.92815C17.3662 6.64788 17.1544 7.31635 16.792 7.87024C16.7874 7.94375 16.7661 8.0183 16.7253 8.08909L14.4831 11.9765C14.2907 12.3101 13.8093 12.3101 13.6169 11.9765L11.3748 8.08909C11.3518 8.04931 11.335 8.00834 11.3239 7.96703C10.9215 7.39501 10.6841 6.69033 10.6841 5.92815C10.6841 4.01515 12.1799 2.46436 14.0251 2.46436C15.8703 2.46436 17.3662 4.01515 17.3662 5.92815ZM14.0251 8.62257C15.4602 8.62257 16.6237 7.41639 16.6237 5.92851C16.6237 4.44062 15.4602 3.23444 14.0251 3.23444C12.5899 3.23444 11.4265 4.44062 11.4265 5.92851C11.4265 7.41639 12.5899 8.62257 14.0251 8.62257Z",
    fill: "#2A2D34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75544 19.7138C5.75517 18.7284 5.58037 16.2706 7.23422 15.2781C9.69815 13.7996 12.2893 16.4701 14.627 17.2496C16.1053 17.7424 18.0774 16.7567 18.0771 15.2781C18.0767 13.7996 16.5985 12.321 15.6128 11.8281",
    stroke: "#2A2D34",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 10.75,
    stroke: "#2A2D34",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravel);
export default __webpack_public_path__ + "static/media/travel.baa496c70c547b1de85497d16606620b.svg";
export { ForwardRef as ReactComponent };